import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["ref"],
    _excluded2 = ["children"],
    _excluded3 = ["children"],
    _excluded4 = ["children"],
    _excluded5 = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import Icon from '../Icon';
import Avatar from '../Avatar';
import { components } from 'react-select';
import { default as ReactSelect } from 'react-select';
import { default as ReactSelectAsync } from 'react-select/async';
import { default as ReactSelectCreatable } from 'react-select/creatable';
import { default as ReactSelectAsyncCreatable } from 'react-select/async-creatable';
import { prefix } from '../../tools/settings';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledAvatar = styled(Avatar).withConfig({
  displayName: "ChipInputstyles__StyledAvatar",
  componentId: "sc-i3h2v5-0"
})(["margin-right:var(--dentsu-spacing-8);> div{line-height:1rem;}"]);
var CustomChipLabel = styled.div.withConfig({
  displayName: "ChipInputstyles__CustomChipLabel",
  componentId: "sc-i3h2v5-1"
})(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]);
var CustomAbbr = styled.span.withConfig({
  displayName: "ChipInputstyles__CustomAbbr",
  componentId: "sc-i3h2v5-2"
})(["font-weight:", ";margin-right:", ";"], function (props) {
  return props.isChip ? 'var(--dentsu-font-weight-regular)' : 'var(--dentsu-font-weight-semibold)';
}, function (props) {
  return props.isChip ? 0 : 'var(--dentsu-spacing-16)';
});
export var GroupHeadingStyles = function GroupHeadingStyles(base, state) {
  return _objectSpread(_objectSpread({}, base), {}, {
    padding: 'var(--dentsu-spacing-8) var(--dentsu-spacing-8) var(--dentsu-spacing-8)',
    fontWeight: 'var(--dentsu-font-weight-semibold)',
    whiteSpace: 'nowrap',
    textTransform: 'uppercase',
    color: 'var(--dentsu-color-n700)',
    lineHeight: 'var(--dentsu-leading-none)',
    fontSize: 'var(--dentsu-font-size-11)'
  });
};
export var ClearIndicator = function ClearIndicator(props) {
  var getStyles = props.getStyles,
      _props$innerProps = props.innerProps,
      ref = _props$innerProps.ref,
      restInnerProps = _objectWithoutProperties(_props$innerProps, _excluded);

  return _jsx("div", _objectSpread(_objectSpread({}, restInnerProps), {}, {
    ref: ref,
    style: getStyles('clearIndicator', props),
    className: "".concat(prefix, "-chip-input__clear"),
    children: _jsx(Icon, {
      icon: "cross",
      color: "var(--dentsu-color-b550)",
      size: 16
    })
  }));
},
    ClearIndicatorStyles = function ClearIndicatorStyles(base) {
  return _objectSpread(_objectSpread({}, base), {}, {
    cursor: 'pointer',
    pointerEvents: 'all',
    zIndex: 1
  });
};
export var SelectContainerStyles = function SelectContainerStyles(base, props) {
  return _objectSpread(_objectSpread({}, base), {}, {
    padding: 0,
    opacity: props.isDisabled ? 0.4 : 1,
    pointerEvents: 'all'
  });
};
export var ControlStyles = function ControlStyles(base, state) {
  return _objectSpread(_objectSpread(_objectSpread({}, base), {}, {
    backgroundColor: state.isFocused ? 'var(--dentsu-color-white)' : state.selectProps.isInvalid ? 'var(--dentsu-color-r100)' : state.selectProps.mode === 'light' ? 'var(--dentsu-color-n50)' : 'var(--dentsu-color-white)',
    boxShadow: state.isFocused ? 'inset 0 1px 0 0 var(--dentsu-color-f500), var(--dentsu-shadow-8)' : state.selectProps.isInvalid ? 'inset 0 1px 0 0 var(--dentsu-color-r600)' : 'inset 0 1px 0 0 var(--dentsu-color-n300)',
    borderColor: 'transparent',
    borderWidth: 0,
    borderRadius: 0,
    color: 'var(--dentsu-color-n1000)',
    minHeight: rem(40)
  }, state.selectProps.maxHeight && {
    maxHeight: state.selectProps.maxHeight,
    overflow: 'auto'
  }), {}, {
    ':hover': {
      backgroundColor: state.isFocused ? 'var(--dentsu-color-white)' : state.selectProps.isInvalid ? 'var(--dentsu-color-r150)' : state.selectProps.mode === 'light' ? 'var(--dentsu-color-n100)' : 'var(--dentsu-color-white)',
      cursor: state.selectProps.isDisabled ? 'not-allowed' : 'default'
    }
  });
};
export var DropdownIndicator = function DropdownIndicator(props) {
  if (props.selectProps.dropdownIcon !== null) {
    return _jsx(components.DropdownIndicator, _objectSpread(_objectSpread({}, props), {}, {
      children: _jsx(Icon, {
        icon: props.selectProps.dropdownIcon,
        color: "var(--dentsu-color-b550)",
        size: 16
      })
    }));
  } else {
    return null;
  }
};
export var IndicatorsContainerStyles = function IndicatorsContainerStyles(base, state) {
  return _objectSpread(_objectSpread({}, base), {}, {
    paddingRight: 'var(--dentsu-spacing-8)',
    paddingTop: 'var(--dentsu-spacing-4)',
    alignItems: 'flex-start',
    svg: {
      fill: 'var(--dentsu-color-b550)'
    }
  });
};
export var IndicatorSeparator = function IndicatorSeparator() {
  return false;
};
export var MenuStyles = function MenuStyles(base) {
  return _objectSpread(_objectSpread({}, base), {}, {
    borderRadius: 0,
    boxShadow: 'var(--dentsu-shadow-8)',
    marginTop: 0,
    zIndex: 999
  });
};
export var MenuPortalStyles = function MenuPortalStyles(base, state) {
  return _objectSpread(_objectSpread({}, base), {}, {
    zIndex: 9999,
    '.dentsu-select__menu > div': {
      overflowY: 'auto'
    }
  });
};
export var MenuListStyles = function MenuListStyles(base) {
  return _objectSpread(_objectSpread({}, base), {}, {
    paddingTop: 0,
    paddingBottom: 0
  });
};
export var Option = function Option(props) {
  var hasAbbr = props.data.abbr ? true : false;
  return _jsxs(components.Option, _objectSpread(_objectSpread({}, props), {}, {
    children: [hasAbbr && _jsx(CustomAbbr, {
      children: props.data.abbr
    }), props.label]
  }));
},
    OptionStyles = function OptionStyles(base, props) {
  return _objectSpread(_objectSpread(_objectSpread({}, base), {}, {
    backgroundColor: props.isFocused ? 'var(--dentsu-color-n50)' : props.isSelected ? 'var(--dentsu-color-n100)' : 'var(--dentsu-color-white)',
    color: 'var(--dentsu-color-n1000)',
    fontSize: 'var(--dentsu-font-size-14)',
    letterSpacing: 'var(--dentsu-tracking-normal)',
    marginBottom: 0,
    minHeight: rem(24),
    padding: 'var(--dentsu-spacing-8) var(--dentsu-spacing-16)'
  }, props.selectProps.hasTruncation && {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }), {}, {
    opacity: props.isDisabled ? 0.4 : 1,
    ':hover': {
      backgroundColor: 'var(--dentsu-color-n50)',
      cursor: props.isDisabled ? 'not-allowed' : 'default'
    }
  });
};
export var MultiValueContainer = function MultiValueContainer(_ref) {
  var _props$selectProps$cu, _props$selectProps, _props$data, _props$selectProps2, _props$selectProps2$a;

  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded2);

  var valueKey = (_props$selectProps$cu = (_props$selectProps = props.selectProps) === null || _props$selectProps === void 0 ? void 0 : _props$selectProps.customValueKey) !== null && _props$selectProps$cu !== void 0 ? _props$selectProps$cu : 'value';
  var isAllOption = ((_props$data = props.data) === null || _props$data === void 0 ? void 0 : _props$data[valueKey]) === ((_props$selectProps2 = props.selectProps) === null || _props$selectProps2 === void 0 ? void 0 : (_props$selectProps2$a = _props$selectProps2.allOption) === null || _props$selectProps2$a === void 0 ? void 0 : _props$selectProps2$a[valueKey]);

  if (isAllOption) {
    return null;
  } else {
    return _jsx(components.MultiValueContainer, _objectSpread(_objectSpread({}, props), {}, {
      children: children
    }));
  }
},
    MultiValueContainerStyles = function MultiValueContainerStyles(base, props) {
  return _objectSpread(_objectSpread({}, base), {}, {
    backgroundColor: 'var(--dentsu-color-n100)',
    border: '1px solid var(--dentsu-color-n250)',
    borderRadius: 'var(--dentsu-radius-12)',
    height: rem(24),
    margin: 'var(--dentsu-spacing-4)',
    paddingLeft: props.selectProps.hasAvatar ? 'var(--dentsu-spacing-4)' : 'var(--dentsu-spacing-8)',
    paddingRight: 0,
    maxWidth: 'calc(100% - var(--dentsu-spacing-48))'
  });
};
export var MultiValueLabel = function MultiValueLabel(_ref2) {
  var _props$data2;

  var children = _ref2.children,
      props = _objectWithoutProperties(_ref2, _excluded3);

  var hasAbbr = props.data.abbr ? true : false;
  var hasAvatar = props.selectProps.hasAvatar;
  return _jsxs(components.MultiValueLabel, _objectSpread(_objectSpread({}, props), {}, {
    children: [hasAvatar && _jsx(StyledAvatar, {
      size: "medium",
      name: props.data.label,
      src: (_props$data2 = props.data) === null || _props$data2 === void 0 ? void 0 : _props$data2.image
    }), hasAbbr ? _jsx(CustomAbbr, {
      isChip: true,
      children: props.data.abbr
    }) : _jsx(CustomChipLabel, {
      children: children
    })]
  }));
},
    MultiValueLabelStyles = function MultiValueLabelStyles(base, props) {
  return {
    color: 'var(--dentsu-color-n1000)',
    display: 'flex',
    alignItems: 'center',
    fontSize: 'var(--dentsu-font-size-12)',
    lineHeight: 'var(--dentsu-leading-none)',
    letterSpacing: 'var(--dentsu-tracking-normal)',
    padding: 0,
    overflow: 'hidden'
  };
};
var MultiValueRemoveFixed = styled.div.withConfig({
  displayName: "ChipInputstyles__MultiValueRemoveFixed",
  componentId: "sc-i3h2v5-3"
})(["background-color:'var(--dentsu-color-n100)';border:'1px solid var(--dentsu-color-n250)';width:", ";height:", ";display:flex;align-items:center;justify-content:center;border-radius:100%;margin:-1px -1px 0 var(--dentsu-spacing-8);line-height:var(--dentsu-leading-none);outline:0 none;flex:0 0 auto;&:hover{background-color:'var(--dentsu-color-n50)';cursor:not-allowed;}"], rem(24), rem(24));
export var MultiValueRemove = function MultiValueRemove(props) {
  if (props.data.isFixed) {
    return _jsx(MultiValueRemoveFixed, {
      hasError: props.data.isError,
      children: _jsx(Icon, {
        icon: "lock",
        color: "var(--dentsu-color-b550)",
        size: 10
      })
    });
  } else {
    return _jsx(components.MultiValueRemove, _objectSpread(_objectSpread({}, props), {}, {
      children: _jsx(Icon, {
        icon: "cross",
        color: "var(--dentsu-color-b550)",
        size: 12
      })
    }));
  }
},
    MultiValueRemoveStyles = function MultiValueRemoveStyles(base, props) {
  return _objectSpread(_objectSpread({}, base), {}, {
    backgroundColor: 'var(--dentsu-color-n100)',
    border: '1px solid var(--dentsu-color-n250)',
    width: rem(24),
    height: rem(24),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '100%',
    margin: '-1px -1px 0 var(--dentsu-spacing-8)',
    lineHeight: 'var(--dentsu-leading-none)',
    outline: '0 none',
    flex: '0 0 auto',
    ':hover': {
      backgroundColor: 'var(--dentsu-color-n50)',
      cursor: 'pointer'
    }
  });
};
export var PlaceholderStyles = function PlaceholderStyles(base, state) {
  return _objectSpread(_objectSpread({}, base), {}, {
    color: state.selectProps.isInvalid ? 'var(--dentsu-color-n1000)' : 'var(--dentsu-color-n700)',
    fontSize: 'var(--dentsu-font-size-14)',
    paddingLeft: 'var(--dentsu-spacing-32)'
  });
};
export var SingleValue = function SingleValue(_ref3) {
  var children = _ref3.children,
      props = _objectWithoutProperties(_ref3, _excluded4);

  var hasAbbr = props.data.abbr ? true : false;
  var hasAvatar = props.selectProps.hasAvatar;
  return _jsxs(components.SingleValue, _objectSpread(_objectSpread({}, props), {}, {
    children: [hasAvatar && _jsx(StyledAvatar, {
      size: "medium",
      name: props.data.label,
      src: props.data.image
    }), hasAbbr ? _jsx(CustomAbbr, {
      isChip: true,
      children: props.data.abbr
    }) : _jsx(CustomChipLabel, {
      children: children
    })]
  }));
},
    SingleValueStyles = function SingleValueStyles(state, props) {
  return {
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    color: 'var(--dentsu-color-n1000)',
    backgroundColor: 'var(--dentsu-color-n100)',
    border: '1px solid var(--dentsu-color-n250)',
    borderRadius: 'var(--dentsu-radius-12)',
    fontSize: 'var(--dentsu-font-size-12)',
    letterSpacing: 'var(--dentsu-tracking-normal)',
    lineHeight: 'var(--dentsu-leading-none)',
    height: rem(24),
    maxWidth: 'calc(100% - var(--dentsu-spacing-48))',
    margin: 'var(--dentsu-spacing-4)',
    paddingLeft: props.selectProps.hasAvatar ? 'var(--dentsu-spacing-4)' : 'var(--dentsu-spacing-8)',
    paddingRight: 'var(--dentsu-spacing-8)'
  };
};
var SearchIcon = styled(Icon).withConfig({
  displayName: "ChipInputstyles__SearchIcon",
  componentId: "sc-i3h2v5-4"
})(["margin:0 var(--dentsu-spacing-8);"]);
export var ValueContainer = function ValueContainer(_ref4) {
  var children = _ref4.children,
      props = _objectWithoutProperties(_ref4, _excluded5);

  return _jsxs(components.ValueContainer, _objectSpread(_objectSpread({}, props), {}, {
    children: [_jsx(SearchIcon, {
      icon: "search",
      color: "var(--dentsu-color-n650)",
      size: 16
    }), children]
  }));
},
    ValueContainerStyles = function ValueContainerStyles(base) {
  return _objectSpread(_objectSpread({}, base), {}, {
    padding: 'var(--dentsu-spacing-4)'
  });
};

var chipInputWidth = function chipInputWidth(props) {
  if (typeof props.width === 'number') {
    return props.width + 'px';
  } else {
    return props.width;
  }
};

export var StyledChipInput = styled(ReactSelect).withConfig({
  displayName: "ChipInputstyles__StyledChipInput",
  componentId: "sc-i3h2v5-5"
})(["max-width:", ";width:", ";"], function (props) {
  return props.isFullWidth || props.width ? 'none' : rem(400);
}, function (props) {
  return props.width ? chipInputWidth : '100%';
});
export var StyledChipInputAsync = styled(ReactSelectAsync).withConfig({
  displayName: "ChipInputstyles__StyledChipInputAsync",
  componentId: "sc-i3h2v5-6"
})(["max-width:", ";width:", ";"], function (props) {
  return props.isFullWidth || props.width ? 'none' : rem(400);
}, function (props) {
  return props.width ? chipInputWidth : '100%';
});
export var StyledChipInputCreatable = styled(ReactSelectCreatable).withConfig({
  displayName: "ChipInputstyles__StyledChipInputCreatable",
  componentId: "sc-i3h2v5-7"
})(["max-width:", ";width:", ";"], function (props) {
  return props.isFullWidth || props.width ? 'none' : rem(400);
}, function (props) {
  return props.width ? chipInputWidth : '100%';
});
export var StyledChipInputAsyncCreatable = styled(ReactSelectAsyncCreatable).withConfig({
  displayName: "ChipInputstyles__StyledChipInputAsyncCreatable",
  componentId: "sc-i3h2v5-8"
})(["max-width:", ";width:", ";"], function (props) {
  return props.isFullWidth || props.width ? 'none' : rem(400);
}, function (props) {
  return props.width ? chipInputWidth : '100%';
});